const getDiffInSecondsBetweenTwoDates = (dateA: Date, dateB: Date): number => {
  if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
    throw new Error(
      'Dates passed to "getDiffInSecondsBetweenTwoDates" are possibly invalid',
    );
  }

  return parseFloat(
    (Math.abs(dateA.getTime() - dateB.getTime()) / 1000).toFixed(2),
  );
};

export default getDiffInSecondsBetweenTwoDates;
